var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _ellipse, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulkUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 129,
    viewBox: "0 0 110 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0601576 12.1321C0.0601576 5.45946 5.41406 0 12.0312 0H55.1633C58.3516 0 61.4195 1.27387 63.6453 3.57898L92.7008 32.8781C94.9867 35.1226 96.25 38.2163 96.25 41.4313V109.189C96.25 115.862 90.8359 121.321 84.2188 121.321H11.9711C5.3539 121.321 0 115.862 0 109.189L0.0601576 12.1321Z",
    fill: "#DFDFDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6389 28.2002V3.07031L93.1945 33.7846H68.1945C65.1389 33.7846 62.6389 31.2716 62.6389 28.2002Z",
    fill: "#D0D0D0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.3334,
    y: 69.1055,
    width: 39.7222,
    height: 6.14286,
    rx: 3.07143,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3334,
    y: 36.8555,
    width: 19.8611,
    height: 6.14286,
    rx: 3.07143,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3334,
    y: 81.3945,
    width: 39.7222,
    height: 6.14285,
    rx: 3.07143,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3334,
    y: 49.1445,
    width: 19.8611,
    height: 6.14286,
    rx: 3.07143,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3334,
    y: 93.6797,
    width: 39.7222,
    height: 6.14285,
    rx: 3.07143,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.2083,
    cy: 99.0519,
    rx: 29.7917,
    ry: 29.9464,
    fill: "#F05B94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.006 115.176H85.3911C86.8191 115.176 87.9874 113.969 87.9874 112.493V99.0783H92.1155C94.4262 99.0783 95.5946 96.1807 93.9589 94.4904L82.0419 82.1754C81.5569 81.673 80.8983 81.3906 80.2115 81.3906C79.5248 81.3906 78.8662 81.673 78.3812 82.1754L66.4642 94.4904C64.8285 96.1807 65.9709 99.0783 68.2816 99.0783H72.4097V112.493C72.4097 113.969 73.578 115.176 75.006 115.176Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkUpload);
export default __webpack_public_path__ + "static/media/bulk-upload.7a201213.svg";
export { ForwardRef as ReactComponent };